import { useEffect } from 'react';

function useUnmountEffect(callback) {
    return useEffect(function () { return function () { return callback(); }; }, []);
}

export { useUnmountEffect };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
// module id = 58
// module chunks = 0